export enum NatDateiTyp {
  ABKUERZUNGEN = 5,
  AQUAKULTUR = 6,
  GEFLUEGEL = 7,
  RIND = 8,
  SCHWEIN = 9,
  SOE = 10,
  TUS = 11,
  SCHATZI = 12
}
